module.exports = __webpack_public_path__ + "img/otf (2).2b409856.svg";